import type { SyntheticEvent } from "react";

import { SWReactIcons } from "@similarweb/icons";

import { MediaPreview } from "app/components/media-preview/MediaPreview";
import { allTrackers } from "app/services/track/track";

import type { AdsGalleryData } from "../hooks/useAdsGallery";
import { UnavailableText } from "../StyledComponents";

type ModalImageProps = Pick<AdsGalleryData, "dimensions" | "creativeImageUri" | "creativeType" | "videoUrl">;

const handleVideoPlay = () => {
    allTrackers.dispatchTrackEvent("Pop Up", "click", "Ads/play");
};

const handleVideoPause = () => {
    allTrackers.dispatchTrackEvent("Pop Up", "click", "Ads/pause");
};

const handleVideoEnded = () => {
    allTrackers.dispatchTrackEvent("Pop Up", "click", "Ads/complete");
};

const handleVideoVolumeChange = (event: SyntheticEvent<HTMLVideoElement>) => {
    const video = event.target as HTMLVideoElement;
    allTrackers.dispatchTrackEvent("Pop Up", "click", "Ads/" + (video.muted ? "mute" : "unmute"));
};

export const ModalImage = ({ dimensions, creativeImageUri, creativeType, videoUrl }: ModalImageProps) => {
    const isVideo = creativeType === "video";
    const downloadUrl = isVideo ? videoUrl : creativeImageUri;

    const handleDownload = () => {
        allTrackers.dispatchTrackEvent("Download", "submit-ok", `Ads/Single/${creativeType}`);
    };

    return (
        <MediaPreview.Container dataAutomation="ad-modal-image">
            {downloadUrl ? (
                <MediaPreview.DownloadButton
                    href={downloadUrl}
                    onClick={handleDownload}
                />
            ) : null}
            <MediaPreview.Loader />
            {isVideo ? (
                <>
                    <MediaPreview.Error>
                        <UnavailableText marginBottom={16}>
                            ad.intelligence.advertiser.ad.card.video.error
                        </UnavailableText>
                        <SWReactIcons
                            iconName="play"
                            size="xl"
                        />
                    </MediaPreview.Error>
                    <MediaPreview.Video
                        src={videoUrl}
                        poster={creativeImageUri}
                        dimensions={dimensions}
                        onPlay={handleVideoPlay}
                        onPause={handleVideoPause}
                        onEnded={handleVideoEnded}
                        onVolumeChange={handleVideoVolumeChange}
                    />
                </>
            ) : (
                <>
                    <MediaPreview.Error>
                        <SWReactIcons
                            iconName="image"
                            size="md"
                        />
                    </MediaPreview.Error>
                    {creativeImageUri ? (
                        <MediaPreview.Image
                            src={creativeImageUri}
                            dimensions={dimensions}
                        />
                    ) : null}
                </>
            )}
        </MediaPreview.Container>
    );
};
